import Vue from 'vue'
import { USER_INFO} from "@/store/mutation-types"
import { getAction, postAction } from '@/api/manage'
export const GroupType={
  data(){
    return{
      getGroupTypeResult:"",
      countChange:0,      
    }
  },
  created(){
    this.getGroupType()
  },
  watch:{
    "form":{
      handler (val) {
        if (val) {
          this.countChange++
        } 
      },
      immediate:false,
      deep:true
    }
  },
  methods:{
    setFilesType(file){
      let fileType = file.name.substring(file.name.lastIndexOf('.') + 1);
      const fileTypes=["exe","bat","cmd","out","sh"];
      if(fileTypes.indexOf(fileType)!=-1){
        this.$message.error(this.language['ipsys.uoloadWarn4']);
        return false;
      }else
      return true;
    },
    getGroupType(){
      let groupTypeRoleCodeList=Vue.ls.get(USER_INFO).roleCodes;
      if(groupTypeRoleCodeList.indexOf("FIHIpsys")!=-1){
        this.getGroupTypeResult='ipsystbs'
      }else  if(groupTypeRoleCodeList.indexOf("FIIIpsys")!=-1){
        this.getGroupTypeResult='ipsystur'
      }
      else{
        this.getGroupTypeResult='ipsys'
      }
      return  this.getGroupTypeResult;
    },
   saveInforLog(ipsysParams){    
    let pureposeed=ipsysParams.purepose;
    if(ipsysParams.url!=''&&ipsysParams.url!=null){
      pureposeed=pureposeed+ ipsysParams.url.substring(ipsysParams.url.lastIndexOf("/") + 1).split("?")[0];
    }    
    let param={menueKey:ipsysParams.menueKey,purepose:pureposeed,systemType:ipsysParams.systemType,formId:ipsysParams.formId,fromNo:ipsysParams.fromNo}
    postAction('/ipsys/hhipm/logInfor/saveLog', param)
    .then((res) => {
      if (res.code === 200) {         
       } 
      })
       .catch((e) => {
      })
   },
   getfilesName(oldeArr,newArr){
    if(Array.isArray(oldeArr)&&oldeArr.length>0){
      if(newArr.length==0){
        return oldeArr.map(file=>{
          if(file.fileInfo ==null||file.fileInfo==''||file.fileInfo.name==''){
              return null
            }else
              return file.fileInfo.name
        }).toString()
      }else{
      return oldeArr.filter(item=>newArr.some(e=>e.id!==item.id)).map(file=>{
        if(file.fileInfo==null||file.fileInfo==''||file.fileInfo.name==''){
          return ""
        }else
          return file.fileInfo.name
        }).toString()
      }
    }
    },
   saveAttFiles(baseId,filelist,ipsysParmas){
      if(!baseId){
        if(filelist&&filelist.length>0){
          let fileNames=filelist.map(file=>{
            return file.filePath.substring(file.filePath.lastIndexOf("/") + 1).split("?")[0]
          }).toString()
          ipsysParmas.purepose='上传附件，附件名称是：'+fileNames
          this.saveInforLog(ipsysParmas)
        }
      }
    },
    // 下载文件
   handleExportExcel(url, fileName, fileType, params = null) {
      if (!fileName || typeof fileName != 'string') {
        fileName = '导出文件'
      }  
      let data = Object.assign({ ...this.queryParam }, { ...this.subQueryParam })
      data.ids = !this.selectedRowKeys.length ? ['all'] : this.selectedRowKeys
      console.log('导出参数data', data)
      this.downFilePost(url, params, data).then((res) => {
        if (!res) {
           this.$message.warning('文件下载失败')
          return
        }
        let date = new Date()
        let dateStr = moment(date).format('YYYY-MM-DD HHmmss')
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([responseType], { type: 'application/vnd.ms-excel' }),
            fileName + dateStr + '.' + fileType)
        } else {
          let url = window.URL.createObjectURL(new Blob([res], { type: 'application/vnd.ms-excel' }))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName + dateStr + '.' + fileType) // 也可使用 link.download = fileName 定义下载文件名
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象          
        }
      })
    }
  }
}
